import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Grid, Chip, Typography, IconButton } from '@mui/material';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CloseIcon from '@mui/icons-material/Close';

function AttachedFilesModal({ open, onClose, attachments, onOpenFilePreview, title }) {
  if (!attachments || attachments.length === 0) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" component="h2">{title || 'All Attached Files'}</Typography>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          {attachments.map(attachment => (
            <Grid item key={attachment.id}>
              <Chip
                icon={<AttachmentIcon />}
                label={attachment.originalFileName}
                onClick={() => onOpenFilePreview(attachment)}
                variant="outlined"
                clickable
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default AttachedFilesModal;